// @ts-ignore - no @types/amzn__graphene-state-graph available
import {StateMachineExecutionGraph} from '@amzn/graphene-state-graph/';
import '@amzn/graphene-state-graph/workflowGraph.css'
import React, {useEffect} from 'react'

const DEFAULT_GRAPH_OPTIONS = {
  layout: 'TB',
  resizeHeight: true,
  hideTooltip: false,
  width: 1000
};

export interface GraphOptions {
  layout: string
  resizeHeight: boolean
  hideTooltip: boolean
  width: number
}

/**
 * @property {string} stateMachineDefinition - The definition used to render the state machine
 * @property {Array<any>} historyEvents - The execution history of the state machine

 */
interface StateGraphExecutionViewerProps {
  stateMachineDefinition: any
  historyEvents: any
}

const renderStateMachineExecutionGraph = async (stateMachineDefinition: any, historyEvents: any, graphOptions: GraphOptions | undefined) => {
  if (!stateMachineDefinition) {
    return;
  }
  const graph = new StateMachineExecutionGraph(stateMachineDefinition, {events: [...historyEvents]}, '#svg-container', graphOptions);
  graph.render();
};

/**
 * StateGraphExecutionViewer renders the Execution Graph of the state machine definition and
 * execution history that are passed in.
 * It additionally takes in componentId to ensure multiple State Graphs can be rendered on the same page.
 */
const StepFunctionsGraph = (props: StateGraphExecutionViewerProps) => {
  const {stateMachineDefinition, historyEvents} = props

  const graphOptions = DEFAULT_GRAPH_OPTIONS

  useEffect(() => {
    renderStateMachineExecutionGraph(stateMachineDefinition, historyEvents, graphOptions)
  }, [stateMachineDefinition, historyEvents])

  return (
      <div style={{ display: 'inline-block' }} id='svg-container' data-testid='svg-container'>
        <svg style={{width: "100%", height: "100%", objectFit: "contain"}}>
        </svg>
      </div>

  )
}

export default StepFunctionsGraph;
